module.exports = __webpack_public_path__ + "static/media/appointments-sample.0d00d87a.csv";